import { render } from "./ProjectBaseView.vue?vue&type=template&id=70424516&scoped=true"
import script from "./ProjectBaseView.vue?vue&type=script&lang=js"
export * from "./ProjectBaseView.vue?vue&type=script&lang=js"

import "./ProjectBaseView.vue?vue&type=style&index=0&id=70424516&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70424516"]])

export default __exports__